import React, { useEffect, useState } from "react";
import { get, put, post } from "../../server";
import { ADD_TEAM_MEMBER, USER } from "../../utils/constants/apiUrl";
import { loggedInUser } from "../../utils/store";
import { useAtom } from "jotai";
import Loader from "../../components/Loader";
import showToast from "../../helpers/showToast";
import { useParams, useNavigate, Link } from "react-router-dom";
import SettingsInput from "../../components/Forms/SettingsInput";
import { AddEditTeamMemberSchema } from "../../utils/SchemasValidation/AddEditUserSchema";
// import AddEditUserSchema from "../../utils/SchemasValidation/AddEditUserSchema";
import ValidateSchema from "../../helpers/ValidateSchema";
import person from "../../assets/images/settings_page_icons/person.svg";
import emailicon from "../../assets/images/settings_page_icons/email.svg";
import location from "../../assets/images/settings_page_icons/location.svg";
// import passwordIcon from "../../assets/images/signup_icons/lock.svg";
import PhoneInput from "react-phone-input-2";
import jobIcon from "../../assets/images/settings_page_icons/job.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { validatePhoneWithCountryCode } from "../../utils/functions";
import ImageUpload from "../../components/ImageUpload";
import dummyImage from "../../assets/images/global_icons/dummyimage.svg";
import uploadImage from "../../helpers/uploadImage";
import { trackEvent } from "../../utils/mixpanel";
import { Button, Card } from "react-bootstrap";

let emptyObj = {
  id: "",
  first_name: "",
  last_name: "",
  dob: "",
  gender: "",
  profile_image: "",
  city: "",
  country: "",
  address: "",
  phone_number: "",
  job_title: "",
  email: "",
  // password: "",
  // confirm_password: "",
  user_social_media: [],
};

const AddEditTeamMember = ({ adminMode = false }) => {
  const { userId, teamId } = useParams();

  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [profile, setProfile] = useState(emptyObj);
  const [imagePath, setImagePath] = useState("");

  useEffect(() => {
    if (imagePath) {
      setProfile({ ...profile, profile_image: imagePath });
    }
  }, [imagePath]);

  // Hanlde on change
  const handleChange = (e, i) => {
    const name = e.target.name;
    const value = e.target.value;
    setProfile({ ...profile, [name]: value });
  };

  // Validate form
  const validateForm = () => {
    let profileData = profile;
    if (!userId) delete profileData.id;
    let newErrors = ValidateSchema(profileData, AddEditTeamMemberSchema);
    // let newErrors = ValidateSchema(profileData, AddEditUserSchema);
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return false;

    if (
      profileData.phone_number.length > profileData.country_phone ||
      profileData.phone_number.length === profileData.country_phone
    ) {
      let resultPhone = validatePhoneWithCountryCode(
        profileData.country_phone,
        profileData.phone_number
      );

      if (resultPhone) {
        setErrors({
          phone_number: resultPhone,
        });
        return false;
      }
    }

    return true;
  };

  // Handle Submit
  const handleSubmit = async (e) => {
    if (!validateForm()) return;

    const isNew = !userId;
    const actionSource = isNew ? "Add Team Member" : "Edit Team Member";
    setLoading(true);
    profile.user_social_media.map((ele) => {
      ["updated_at", "created_at", "placeholder"].forEach((e) => delete ele[e]);
    });

    let newDob = profile.dob;
    if (profile.dob) {
      newDob = `${
        newDob.getMonth() + 1
      }/${newDob.getDate()}/${newDob.getFullYear()}`;
    }

    let payload = { ...profile };

    payload.dob = newDob;
    // Password is auto-generated on the backend; do not send these fields.
    // if (!payload.password) delete payload.password;
    // if (!payload.confirm_password) delete payload.confirm_password;
    delete payload.password;
    delete payload.confirm_password;

    if (payload.phone_number && payload.country_phone.length > 0) {
      payload.phone_number = payload.phone_number.slice(
        payload.country_phone.length,
        payload.phone_number.length
      );
    } else {
      payload.country_phone = "";
    }

    if (!payload.phone_number && payload.country_phone) {
      payload.country_phone = "";
    }

    if (payload.profile_image && typeof payload.profile_image == "object") {
      const { status, message, data } = await uploadImage(
        "profile",
        payload.profile_image,
        loggedUser?.token
      );

      if (status) {
        payload.profile_image = data;
      } else {
        showToast(status, message);
        setLoading(false);
        return;
      }
    }

    trackEvent(`${actionSource} Attempt`, {
      user_id: userId || "new",
      data: { ...payload },
    });
    if (userId) {
      let { status, message } = await put(
        `${USER}/${userId}`,
        payload,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      trackEvent(`${actionSource} ${status ? "Success" : "Failed"}`, {
        user_id: userId,
        status,
        message,
        data: { ...payload },
      });
      if (status) {
        navigate(-1);
      }

      showToast(status, message);
    } else {
      payload.team_id = adminMode
        ? Number(teamId)
        : Object.keys(loggedUser).length !== 0
          ? loggedUser.teams.id
          : null;
      let { status, message } = await post(
        `${ADD_TEAM_MEMBER}`,
        payload,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      trackEvent(`${actionSource} ${status ? "Success" : "Failed"}`, {
        user_id: "new",
        status,
        message,
        data: { ...payload },
      });
      if (status) {
        navigate(-1);
      }
      showToast(status, message);
    }
    setLoading(false);
  };

  // load user
  const loadUser = async () => {
    setLoading(true);
    let { status, message, data } = await get(
      USER + "/" + userId,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      setImagePath(data.profile_image);

      if (data.dob) {
        data.dob = new Date(data.dob);
      }

      if (data.country_phone) {
        data.country_phone = `${data.country_phone}`;
      } else {
        data.country_phone = "";
      }

      if (data.phone_number) {
        data.phone_number = `${data.country_phone ? data.country_phone : ""}${
          data.phone_number
        }`;
      } else {
        data.phone_number = "";
      }

      // data = { ...data, password: "", confirm_password: "" };

      setProfile(data);
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const handleDateChange = (e) => {
    setProfile({ ...profile, dob: e });
  };

  useEffect(() => {
    if (userId) {
      loadUser();
    }
  }, []);

  return (
    <>
      {!loading ? (
        <div className={adminMode ? "admin-add-team-member" : ""}>
          <div className="heading">
            <h1>
              <Link
                to={adminMode ? "#" : "/team/teamMembers"}
                onClick={adminMode ? (event) => { event.preventDefault(); navigate(-1); } : undefined}
                className="function-link"
              >
                Team Members
              </Link>
              {" > "}
              {userId ? "Edit" : "Add"} Team Member
            </h1>
          </div>

          <Card className="bioDataWrapper card">
            <Card.Body>
              <h4 className="mb-4">Account Info</h4>
              <div className="imageWrapper">
                <ImageUpload
                  imageLink={true}
                  imageUrl={imagePath}
                  setPath={setImagePath}
                  imageType="profile"
                  dummyImage={dummyImage}
                />
                <div>
                  <h6>{`${profile.first_name} ${profile.last_name}`}</h6>
                </div>
              </div>
              <div
                className="row"
                style={
                  adminMode
                    ? { marginTop: "24px" }
                    : undefined
                }
              >
                <div className="col-12 col-md-6 col-lg-4">
                  <SettingsInput
                    label="First name"
                    type="text"
                    placeholder="First Name"
                    name="first_name"
                    value={profile.first_name}
                    handleChange={handleChange}
                    // icon={person}
                    error={errors.first_name}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <SettingsInput
                    label="Email"
                    type="text"
                    placeholder="Email"
                    socialProfiles={false}
                    name="email"
                    value={profile.email}
                    handleChange={handleChange}
                    // icon={emailicon}
                    error={errors.email}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <SettingsInput
                    label="Last name"
                    type="text"
                    placeholder="Last Name"
                    name="last_name"
                    value={profile.last_name}
                    handleChange={handleChange}
                    // icon={person}
                    error={errors.last_name}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <SettingsInput
                    label="Live in"
                    type="text"
                    placeholder="Live in"
                    socialProfiles={false}
                    name="city"
                    value={profile.city}
                    handleChange={handleChange}
                    // icon={location}
                    error={errors.city}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group">
                    <label htmlFor="" className="label">
                      Contact Number
                    </label>
                    <PhoneInput
                      country={"us"}
                      enableSearch={true}
                      countryCodeEditable={false}
                      inputClass={
                        errors.phone_number
                          ? "phoneNumberInput errorInput"
                          : "phoneNumberInput"
                      }
                      value={profile.phone_number}
                      onChange={(value, country, e, formattedValue) => {
                        setProfile({
                          ...profile,
                          phone_number: value,
                          country_phone: country.dialCode,
                        });
                      }}
                    />
                    <span className="errorText">{errors.phone_number}</span>
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <SettingsInput
                    label="Country"
                    type="text"
                    placeholder="Country"
                    socialProfiles={false}
                    name="country"
                    value={profile.country}
                    handleChange={handleChange}
                    // icon={location}
                    error={errors.country}
                  />
                </div>
                {/* Password fields hidden — backend auto-generates password on add team member
                {!userId && (
                  <>
                    <div className="col-12 col-md-6 col-lg-4">
                      <SettingsInput
                        label="Password"
                        type="password"
                        placeholder="********"
                        socialProfiles={false}
                        name="password"
                        value={profile.password}
                        handleChange={handleChange}
                        icon={passwordIcon}
                        error={errors.password}
                      />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <SettingsInput
                        label="Confirm Password"
                        type="password"
                        placeholder="********"
                        socialProfiles={false}
                        name="confirm_password"
                        value={profile.confirm_password}
                        handleChange={handleChange}
                        // icon={passwordIcon}
                        error={errors.confirm_password}
                      />
                    </div>
                  </>
                )}
                */}
                <div className="col-md-6 col-lg-4 col-12">
                  <div className="form-group">
                    <label htmlFor="" className="label">
                      Date of Birth
                    </label>
                    <DatePicker
                      selected={profile.dob}
                      onChange={handleDateChange}
                      dateFormat="MM/dd/yyyy"
                      className="dobInput form-control"
                      placeholderText="MM/dd/yyyy"
                      showYearDropdown
                      isClearable
                      maxDate={new Date()}
                      yearDropdownItemNumber={110}
                      scrollableYearDropdown
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-12">
                  <SettingsInput
                    label="Job, Position"
                    type="text"
                    placeholder="Photographer"
                    socialProfiles={false}
                    name="job_title"
                    value={profile.job_title}
                    handleChange={handleChange}
                    // icon={jobIcon}
                    error={errors.job_title}
                  />
                </div>
                <div className="col-md-6 col-lg-4 col-12">
                  <div className="selectWrapper">
                    <div className="form-group">
                      <label className="label">Gender</label>
                      <select
                        className="form-select customSelect form-control"
                        name="gender"
                        value={profile.gender}
                        onChange={handleChange}
                      >
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Prefer not to say</option>
                      </select>
                      <span className="errorText">{errors.gender}</span>
                    </div>
                  </div>
                </div>
              </div>
              <Button varient="primary" type="button" onClick={handleSubmit}>
                {userId ? "Update" : "Add"} Member
              </Button>
            </Card.Body>
          </Card>
          {adminMode && <style type="text/css">{`
            .admin-add-team-member {
              --table-color: #ffffff;
              --body-color: #f8faf9;
              --secondary_color: #ffffff;
              --primary_text_color: #212529;
              --heading_text_color: #212529;
              --light-black: #212529;
              --color-black: #212529;
              --border-color: #dee2e6;
              color: #212529;
            }
            .admin-add-team-member .bioDataWrapper,
            .admin-add-team-member .card,
            .admin-add-team-member .card-body,
            .admin-add-team-member .form-control,
            .admin-add-team-member .form-select,
            .admin-add-team-member .react-tel-input .flag-dropdown {
              background-color: #ffffff !important;
              color: #212529 !important;
            }
            .admin-add-team-member .bioDataWrapper {
              border: 1px solid #dee2e6;
            }
            .admin-add-team-member .imageWrapper h6 {
              margin-top: 10px;
            }
            .admin-add-team-member .form-control,
            .admin-add-team-member .form-select,
            .admin-add-team-member .dobInput,
            .admin-add-team-member .phoneNumberInput {
              border: 1px solid #cbd3da !important;
              box-shadow: none !important;
            }
            .admin-add-team-member .react-tel-input .flag-dropdown {
              border: 1px solid #cbd3da !important;
              border-right: 0 !important;
            }
            .admin-add-team-member .react-tel-input .phoneNumberInput {
              border-left: 1px solid #cbd3da !important;
            }
            .admin-add-team-member .react-tel-input,
            .admin-add-team-member .react-tel-input .phoneNumberInput {
              width: 100% !important;
            }
            .admin-add-team-member .form-control:focus,
            .admin-add-team-member .form-select:focus,
            .admin-add-team-member .dobInput:focus,
            .admin-add-team-member .phoneNumberInput:focus {
              border-color: #58a388 !important;
              box-shadow: 0 0 0 2px rgba(88, 163, 136, 0.14) !important;
            }
          `}</style>}
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default AddEditTeamMember;
